import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { changeSection, reserveSection, validarReserva } from "../Api/reservation";
import { IReserveRequest } from "../types";
import { RootState } from "../app/store";
import { ISubjectsSliceState } from "../reduxSlices/subjectsSlice";
import { conf } from "../utils/config";

// --------------------- Cambio de sección ---------------------
export const changeSectionThunk = createAsyncThunk<any, IReserveRequest, { state: RootState }>(
  "front/changeSection",
  async (reserveData: IReserveRequest, thunkAPI) => {
    try {
      // Validación previa si está habilitada mediante variable de entorno
      const shouldPreValidate = conf("PRE_VALIDATE_TX") === "true";
      let idTx: number | undefined = undefined;
      let tsInicio: number | undefined = undefined;
      
      if (shouldPreValidate) {
        const validationResponse = await validarReserva({
          idC: reserveData.idC,
          idS: reserveData.idS,
          idA: reserveData.idA,
          tim: reserveData.tim,
          tic: reserveData.tic,
          aL: reserveData.aL,
          idPersona: reserveData.idPersona ? Number(reserveData.idPersona) : undefined,
          idMateria: reserveData.idMateria,
          idTx: reserveData.idTx,
          esCambioSeccion: true,
        });

        // Verificar si hay un error HTTP o si la validación falló
        const mensajeError = validationResponse.data?.mensaje || "Error al validar el cambio de sección";
        const validacionExitosa = validationResponse.data?.esValido || false;
        idTx = validationResponse.data?.idTx || undefined;

        // Rechazar si hay error HTTP o si la validación no fue exitosa
        if (validationResponse.status !== 200 || !validacionExitosa) {
          return thunkAPI.rejectWithValue(mensajeError);
        }
      }

      // Ejecutar el cambio de sección
      const response = await changeSection({
        idC: reserveData.idC,
        idS: reserveData.idS,
        idA: reserveData.idA,
        tim: reserveData.tim,
        tic: reserveData.tic,
        aL: reserveData.aL,
        idPersona: reserveData.idPersona ? Number(reserveData.idPersona) : undefined,
        idMateria: reserveData.idMateria,
        idTx: idTx,
        tsInicio: tsInicio,
        esCambioSeccion: true,
      });

      if (response.data.responseCode !== 200) {
        return thunkAPI.rejectWithValue(response.data.responseMessage);
      }

      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const changeSectionBuilder = (builder: ActionReducerMapBuilder<ISubjectsSliceState>) => {
  builder.addCase(changeSectionThunk.pending, (state, action) => {
    const { aL: anioLectivo, idS: idCurso } = action.meta.arg;
    // Agregar a la lista de procesos en curso
    const index = state.subcriptionProcessSectionIds.findIndex(
      (item) => item.idCurso === idCurso && item.anioLectivo === anioLectivo
    );
    if (index === -1) {
      state.subcriptionProcessSectionIds.push({ idCurso, anioLectivo });
    }
  });

  builder.addCase(changeSectionThunk.fulfilled, (state, action) => {
    // Remover de la lista de procesos en curso al completarse exitosamente
    // Se quita de la lista al recibir el socket con la respuesta de Oracle
  });

  builder.addCase(changeSectionThunk.rejected, (state, action) => {
    const { aL: anioLectivo, idS: idCurso } = action.meta.arg;
    // Agregar a la lista de procesos fallidos
    // state.failedSubcriptionProcessIds.push({ idCurso, anioLectivo });
    state.failedSubcriptionSyncProcessIds.push({ idCurso, anioLectivo });
    // Remover solo el curso específico que falló, no todos
    state.subcriptionProcessSectionIds = state.subcriptionProcessSectionIds.filter(
      (item) => !(item.idCurso === idCurso && item.anioLectivo === anioLectivo)
    );
    state.sectionChangeInProcess = state.sectionChangeInProcess.filter(
      (item) => !(item.idCurso === idCurso && item.anioLectivo === anioLectivo)
    );
  });
};
// --------------------- Inscripción ---------------------
export const reserveSectionThunk = createAsyncThunk<any, any, { state: RootState }>(
  "front/reserveSection",
  async (reserveData: IReserveRequest, thunkAPI) => {
    try {
      // Validación previa si está habilitada mediante variable de entorno
      const shouldPreValidate = conf("PRE_VALIDATE_TX") === "true";
      let idTx: number | undefined = undefined;
      let tsInicio: number | undefined = undefined;
      if (shouldPreValidate) {
        const validationResponse = await validarReserva({
          idC: reserveData.idC,
          idS: reserveData.idS,
          idA: reserveData.idA,
          tim: reserveData.tim,
          tic: reserveData.tic,
          aL: reserveData.aL,
          idPersona: Number(reserveData.idPersona),
          idMateria: reserveData.idMateria,
        });

        // Verificar si hay un error HTTP o si la validación falló
        const mensajeError = validationResponse.data?.mensaje || "Error al validar la reserva";
        const validacionExitosa = validationResponse.data?.esValido || false;
        idTx = validationResponse.data?.idTx || undefined;
        tsInicio = validationResponse.data?.tsInicio || undefined;

        // Rechazar si hay error HTTP o si la validación no fue exitosa
        if (validationResponse.status !== 200 || !validacionExitosa) {
          return thunkAPI.rejectWithValue(mensajeError);
        }
      }

      // Ejecutar la reserva
      const response = await reserveSection({
        idC: reserveData.idC,
        idS: reserveData.idS,
        idA: reserveData.idA,
        tim: reserveData.tim,
        tic: reserveData.tic,
        aL: reserveData.aL,
        idPersona: Number(reserveData.idPersona),
        idMateria: reserveData.idMateria,
        idTx: idTx,
        tsInicio: tsInicio,
      });

      if (response.data.responseCode !== 200) {
        return thunkAPI.rejectWithValue(response.data.responseMessage);
      }

      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const reserveSectionBuilder = (builder: ActionReducerMapBuilder<ISubjectsSliceState>) => {
  builder.addCase(reserveSectionThunk.pending, (state, action) => {
    const { aL: anioLectivo, idS: idCurso } = action.meta.arg as IReserveRequest;
    state.subcriptionProcessSectionIds.push({ idCurso, anioLectivo });
  });
  builder.addCase(reserveSectionThunk.fulfilled, (state, action) => {});
  builder.addCase(reserveSectionThunk.rejected, (state, action) => {
    const { aL: anioLectivo, idS: idCurso } = action.meta.arg as IReserveRequest;
    //state.failedSubcriptionProcessIds.push({ idCurso, anioLectivo });
    state.failedSubcriptionSyncProcessIds.push({ idCurso, anioLectivo });
    
    // Remover solo el curso específico que falló, no todos
    state.subcriptionProcessSectionIds = state.subcriptionProcessSectionIds.filter(
      (item) => !(item.idCurso === idCurso && item.anioLectivo === anioLectivo)
    );
  });
};
// --------------------- Desinscripción ---------------------
